import { SiteMap } from "./SiteMap";

export default SiteMap;
